// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__c8J7t","lastUpdated":"PrivacyPolicy_lastUpdated__bbAI- marketplaceBodyFontStyles","scopedList":"PrivacyPolicy_scopedList__T0GTz"};